export default {
  title: 'HiTeach課堂桌遊',
  pvpGame: '摘星星',
  moleGame: '打地鼠',
  tfGame: '火箭升空',
  pickGame: '挑人轉盤',
  punchBoardGame: '戳戳樂',
  
  // 遊戲說明標題
  gameInfoTitle: '遊戲說明',
  close: '關閉',
  
  // 詞彙掉落說明
  pvpGameTitle: '摘星星',
  pvpGameDesc: '在熱帶小島上，詞語像流星雨般從天而降！\n兩位玩家要在限定時間內，抓住正確詞語、閃避錯誤選項，誰能快速又精準地成為詞彙獵人王？',
  
  // 打地鼠說明
  moleGameTitle: '打地鼠',
  moleGameDesc: '一人對戰！知識版的打地鼠登場～\n地鼠們冒出頭帶來真假資訊，你能在最短時間內準確「敲」出正確答案，擊退那些來搞亂的錯誤嗎？',
  
  // 火箭升空說明
  tfGameTitle: '火箭升空',
  tfGameDesc: '準備升空，智慧對決啟動！\n兩位太空人面對是非題的挑戰，答對才能讓火箭直衝星際，答錯就原地打轉～誰能最先飛出大氣層成為知識宇航員？',
  
  // 挑人轉盤說明
  pickGameTitle: '挑人轉盤',
  pickGameDesc: '轉動命運的轉盤！\n支援個人挑選、組別挑選或自訂選項，讓選擇變得更有趣更公平。轉盤旋轉，答案揭曉！',
  
  // 戳戳樂說明
  punchBoardGameTitle: '戳戳樂',
  punchBoardGameDesc: '戳破驚喜的時刻！\n每個洞都藏著不同的驚喜，戳破表面探索內容。支援多種版面大小和動畫效果，讓選擇充滿期待！',
  
  // 按鈕文字
  play: '開始遊戲'
}